// Generische mobile Top-Leiste der App-Shell — Kalender-Prinzip
// app-weit: 🔥 Marke links, Portal-Outlet in der Mitte (Default: Seitentitel
// aus dem shell-store, sonst Nav-Label-Fallback), 🔔 Glocke rechts. Wird von
// __root NUR bei isPhone && eingeloggt gerendert (JS-Gate, kein
// CSS-Breakpoint) — das Tablet-Band 640–1023 hat seit T2 bewusst KEINE
// Top-Leiste (Seiten zeigen Desktop-Köpfe, Brand + Bell wohnen in der Rail).
//
// Flex-Kind der main-Spalte, KEIN position:fixed: der Scroller darunter
// endet physisch an der Leisten-Unterkante — nichts kann dahinter
// verschwinden, keine Höhenklemmen nötig.

import { Link, useRouterState } from '@tanstack/react-router'
import { Flame } from 'lucide-react'
import { resolveMobileTitle } from '../../lib/mobile-title'
import { useShellStore } from '../../lib/shell-store'
import { NotificationBell } from '../notification-center'
import { useShellOutletStore } from './mobile-shell-outlets'

export function MobileShellTop() {
  const openNotif = useShellStore((s) => s.openNotif)
  const storeTitle = useShellStore((s) => s.title)
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const setTopCenterEl = useShellOutletStore((s) => s.setTopCenterEl)
  const hasCustomCenter = useShellOutletStore((s) => s.topCenterCount > 0)

  const title = storeTitle ?? resolveMobileTitle(pathname) ?? ''

  return (
    <div
      // Safe-Area-Notch als paddingTop (Muster __root-Topbar); im
      // Browser-Tab ist env() = 0. shrink-0: die Leiste gibt im flex-col
      // von main nie Höhe an den Scroller ab.
      className="shell-safe-inline flex shrink-0 items-center gap-0.5 border-b border-border-subtle pb-1"
      style={{ paddingTop: 'var(--app-safe-top)' }}
    >
      {/* ── Marke: 🔥 → Dashboard (☰ lebt in der Bottom-Bar) ── */}
      <Link
        to="/"
        aria-label="Zum Dashboard"
        className="flex h-11 w-11 shrink-0 items-center justify-center text-accent"
      >
        <Flame className="h-5 w-5" strokeWidth={2.25} />
      </Link>

      {/* ── Mitte: Portal-Outlet. Default = truncatender Titel-String.
          Inline minWidth:0 schlägt die globale .no-min-tap-Regel
          (index.css, @media hover:none), falls Seiten Buttons hierher
          portalen — sonst sprengt min-width:min-content die Leiste und
          drückt die Glocke raus (Gotcha der alten Kalender-Leiste). ── */}
      <div
        ref={setTopCenterEl}
        style={{ minWidth: 0 }}
        className="flex h-11 min-w-0 flex-1 items-center justify-center gap-1.5 px-1"
      >
        {!hasCustomCenter && (
          <span className="truncate text-xs font-medium text-text-primary">{title}</span>
        )}
      </div>

      {/* 🔔 — bestehende Bell 1:1 (Unread-Badge bleibt), 44px Tap-Target. */}
      <NotificationBell
        onClick={openNotif}
        className="flex h-11 w-11 shrink-0 items-center justify-center"
      />
    </div>
  )
}
